/**
 * One membership for everyone (owner decision, 2026-10-25): a single plan,
 * one price, every research tool. The feature list is product copy shared by
 * the pricing page, the home page, the free-trial page and the sign-up page;
 * the plan's name and price always come from /platform/plans, so an admin
 * price change shows everywhere.
 */
import type { Plan, PlansResponse } from "@/pages/account/platform";

export interface FeatureGroup {
  title: string;
  items: string[];
}

export const MEMBERSHIP_FEATURES: FeatureGroup[] = [
  {
    title: "Premium tools",
    items: ["Options Strategy Lab", "Stock Strategy Lab", "Market Atlas", "Smart Money Tracker"],
  },
  {
    title: "Research",
    items: [
      "Stock screener",
      "Option chain and F&O dashboards",
      "Options movers",
      "Backtests on years of NSE history",
      "Signal research",
    ],
  },
  {
    title: "Alerts and tracking",
    items: ["Price alerts", "Idea and strategy-score alerts", "Watchlists", "Email alerts"],
  },
  {
    title: "Markets and more",
    items: [
      "Live market pages: indices, movers, sectors, FII/DII",
      "Research Analyst and Investment Adviser directories",
      "“How it works” videos for every tool",
    ],
  },
];

/** The plan new accounts join: the default public, paid investor plan. */
export function membershipPlan(data: PlansResponse | undefined): Plan | undefined {
  const plans = (data?.plans ?? []).filter(
    (p) => p.active && p.role === "investor" && p.price_monthly > 0 && p.public !== false,
  );
  return plans.find((p) => p.is_default) ?? [...plans].sort((a, b) => a.sort_order - b.sort_order)[0];
}
